<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('hospital_configuration.hospital_bed_entry') }}</h4>
          </template>
          <template v-slot:body>
            <b-row>
              <b-col lg="12" sm="12">
                <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                  <b-form  @submit.prevent="handleSubmit(createData)" @reset.prevent="reset" >
                    <b-overlay :show="unitLoad">
                    <b-row>
                      <b-col lg="6" sm="6">
                          <ValidationProvider name="Hopital Nmae" vid="hospital_id" rules="required|min_value:1">
                            <b-form-group
                                class="row"
                                label-cols-sm="4"
                                label-for="hospital_id"
                                slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{$t('hospital_configuration.hos_name')}} <span class="text-danger">*</span>
                                </template>
                                <b-form-select
                                plain
                                :disabled="$route.query.ward_id ? true : false"
                                v-model="hospitalBedData.hospital_id"
                                :options="hospitalList"
                                id="hospital_id"
                                :state="errors[0] ? false : (valid ? true : null)"
                                >
                                <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                {{ errors[0] }}
                                </div>
                            </b-form-group>
                            </ValidationProvider>
                      </b-col>
                       <b-col lg="6" sm="6">
                        <ValidationProvider name="Department Name" vid="department_id" rules="required|min_value:1">
                            <b-form-group
                                class="row"
                                label-cols-sm="4"
                                label-for="department_id "
                                slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{$t('hospital_configuration.dept_name')}} <span class="text-danger">*</span>
                                </template>
                                <b-form-select
                                plain
                                :disabled="$route.query.ward_id ? true : false"
                                v-model="hospitalBedData.department_id"
                                id="department_id"
                                :options="departmentList"
                                :state="errors[0] ? false : (valid ? true : null)"
                                >
                                <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                {{ errors[0] }}
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                       </b-col>
                       <b-col lg="6" sm="6">
                          <ValidationProvider name="Ward Name" vid="ward_id" rules="required|min_value:1">
                            <b-form-group
                                class="row"
                                label-cols-sm="4"
                                label-for="ward_id"
                                slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{$t('hospital_configuration.ward_name')}} <span class="text-danger">*</span>
                                </template>
                                <b-form-select
                                plain
                                :disabled="$route.query.ward_id ? true : false"
                                v-model="hospitalBedData.ward_id"
                                :options="wardList"
                                id="ward_id"
                                :state="errors[0] ? false : (valid ? true : null)"
                                >
                                <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                {{ errors[0] }}
                                </div>
                            </b-form-group>
                            </ValidationProvider>
                      </b-col>
                    </b-row>
                    <hr>
                    <b-row v-for="(item, index) in hospitalBedData.bedData" :key="index">
                        <b-col xs="12" sm="12" md="5" lg="5" xl="5">
                          <ValidationProvider name="Bed No (En)" vid="bed_name" rules="required">
                          <b-form-group
                              class="row"
                              label-cols-sm="4"
                              label-for="bed_name"
                              slot-scope="{ valid, errors }"
                          >
                              <template v-slot:label>
                              {{$t('hospital_configuration.bed_no_en')}} <span class="text-danger">*</span>
                              </template>
                              <b-form-input
                              id="bed_name"
                              v-model="item.bed_name"
                              :state="errors[0] ? false : (valid ? true : null)"
                              ></b-form-input>
                              <div class="invalid-feedback">
                              {{ errors[0] }}
                              </div>
                          </b-form-group>
                          </ValidationProvider>
                      </b-col>
                      <b-col xs="12" sm="12" md="5" lg="5" xl="5">
                          <ValidationProvider name="Bed No (Bn)" vid="bed_name_bn" rules="required">
                          <b-form-group
                              class="row"
                              label-cols-sm="4"
                              label-for="bed_name_bn"
                              slot-scope="{ valid, errors }"
                          >
                              <template v-slot:label>
                              {{$t('hospital_configuration.bed_no_bn')}} <span class="text-danger">*</span>
                              </template>
                              <b-form-input
                              id="bed_name_bn"
                              v-model="item.bed_name_bn"
                              :state="errors[0] ? false : (valid ? true : null)"
                              ></b-form-input>
                              <div class="invalid-feedback">
                              {{ errors[0] }}
                              </div>
                          </b-form-group>
                          </ValidationProvider>
                      </b-col>
                      <b-col lg="2" sm="4">
                          <button type="button" class="btn btn-sm btn-primary" @click.prevent="addItem()" v-show="index == hospitalBedData.bedData.length-1">
                              +
                          </button>&nbsp;&nbsp;
                          <button type="button" class="btn btn- iq-bg-danger btn-sm" @click="deleteItem(index)"
                          v-show="hospitalBedData.bedData.length > 1">
                              <i class="ri-delete-bin-line m-0"></i>
                          </button>
                      </b-col>
                    </b-row>
                    <div class="row">
                      <div class="col-sm-3"></div>
                      <div class="col text-right">
                        <b-button type="submit" variant="primary" class="mr-2">{{ $route.query.ward_id ? $t('globalTrans.update') : $t('globalTrans.save') }}</b-button>
                        &nbsp;
                        <router-link to="/hospital-disability-service/configuration/hospital-bed" :class="'btn btn-danger text-light'">{{  $t('globalTrans.cancel') }}</router-link>
                      </div>
                    </div>
                    </b-overlay>
                  </b-form>
                </ValidationObserver>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { hospitalServiceBaseUrl } from '@/config/api_config'
import { hospitalBedStoreApi, hospitalBedUpdateApi, hospitalBedShowApi, assignUserHospitalApi } from '../../api/routes'

export default {
  props: ['id'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  created () {
    var officeId = this.$store.state.Auth.authUser.office_id
    if (officeId > 1) {
        this.userId = this.$store.state.Auth.authUser.user_id
        if (this.userId > 1) {
            this.getUserWiseHospital(this.userId)
        }
    } else {
        this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1 && item.is_jointly_formated === 0).map((obj, key) => {
            this.hospitalIds.push(obj.value)
        })
        this.hospitalList = this.getHospitalList()
    }
    if (this.$route.query.ward_id) {
      this.getAssignUserData(this.$route.query.ward_id)
    }
  },
  mounted () {
    core.index()
  },
  data () {
    return {
        // saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
        hospitalBedData: {
            id: '',
            hospital_id: 0,
            department_id: 0,
            ward_id: '0',
            bed_name: '',
            bed_name_bn: '',
            status: '',
            bedData: [
              {
                bed_name: '',
                bed_name_bn: ''
              }
            ],
            bedNames: [],
            bedNameBns: []
        },
        bedNameAr: [],
        bedNameBnAr: [],
        hospitalList: [],
        hospitalIds: [],
        departmentList: [],
        wardList: [],
        unitLoad: false
    }
  },
  computed: {
    // hospitalList: function () {
    //   const objectData = this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1 && item.is_jointly_formated === 0)
    //   return objectData.map((obj, key) => {
    //       if (this.$i18n.locale === 'bn') {
    //           return { value: obj.value, text: obj.text_bn }
    //       } else {
    //           return { value: obj.value, text: obj.text_en }
    //       }
    //   })
    // }
  },
  watch: {
    'hospitalBedData.hospital_id': function (newVal, oldVal) {
      if (oldVal !== newVal) {
        this.departmentList = this.getDepartmentList(newVal)
        this.wardList = this.hosWardList()
      }
    },
    'hospitalBedData.department_id': function (newVal, oldVal) {
      if (oldVal !== newVal) {
        this.wardList = this.hosWardList()
      }
    }
  },
  methods: {
    async getUserWiseHospital (userId) {
        const params = Object.assign({ user_id: userId })
        const result = await RestApi.getData(hospitalServiceBaseUrl, assignUserHospitalApi, params)
        if (result.success) {
                this.hospitalIds = result.data
                this.hospitalList = this.getHospitalList()
        } else {
              this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1 && item.is_jointly_formated === 0).map((obj, key) => {
                  this.hospitalIds.push(obj.value)
              })
                    this.hospitalList = this.getHospitalList()
        }
    },
    getHospitalList () {
        let hospitalList = this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1 && item.is_jointly_formated === 0)
        if (this.hospitalIds.length > 0) {
        hospitalList = hospitalList.filter((p) => this.hospitalIds.includes(p.value))
        }
        this.hospitalLoad = false

        return hospitalList
    },
    deleteItem (index) {
        this.hospitalBedData.bedData.splice(index, 1)
        this.hospitalBedData.bedNames.splice(index, 1)
        this.hospitalBedData.bedNameBns.splice(index, 1)
    },
    getDepartmentList (hospitalId) {
      const departments = this.$store.state.HospitalDisabilityService.commonObj.hosAssignDepartmentList.filter(item => item.status === 1)
      if (hospitalId) {
        return departments.filter(department => department.hospital_id === hospitalId)
      }
      return departments
    },
    hosWardList (hosId, deptId) {
      return this.$store.state.HospitalDisabilityService.commonObj.hosWardList.filter(item => item.status === 1 && item.hospital_id === this.hospitalBedData.hospital_id && item.department_id === this.hospitalBedData.department_id).map((obj, key) => {
          if (this.$i18n.locale === 'bn') {
              return { value: obj.value, text: obj.text_bn }
          } else {
              return { value: obj.value, text: obj.text_en }
          }
      })
    },
    // addItem () {
    //     const validate = this.hospitalBedData.bedData.some(data => data.bed_name === this.hospitalBedData.bed_name)
    //     if (this.hospitalBedData.bed_name !== '' && this.hospitalBedData.bed_name_bn !== '') {
    //       if (!validate) {
    //           this.hospitalBedData.bedData.push({
    //              bed_name: '',
    //              bed_name_bn: ''
    //           })
    //           this.hospitalBedData.bedNames.push(this.hospitalBedData.bed_name.toString())
    //           this.hospitalBedData.bedNameBns.push(this.hospitalBedData.bed_name_bn.toString())
    //       } else {
    //       }
    //     } else {
    //     }
    // },
    addItem () {
    this.hospitalBedData.bedData.push({
                 bed_name: '',
                 bed_name_bn: ''
              })
    },
    deptNameById (id) {
        const dept = this.$store.state.HospitalDisabilityService.commonObj.deptList.find(dept => dept.value === id)
        if (this.$i18n.locale === 'bn') {
            return dept.text_bn
        } else {
            return dept.text_en
        }
    },
    async getAssignUserData (wardId) {
      this.unitLoad = true
        const result = await RestApi.getData(hospitalServiceBaseUrl, hospitalBedShowApi + '/' + wardId)
        if (result.success) {
            this.hospitalBedData.hospital_id = result.data.hospital_id
            this.hospitalBedData.department_id = result.data.department_id
            this.hospitalBedData.ward_id = result.data.ward_id
            this.hospitalBedData.bedData = result.data.bedArr
            const bedNameArrData = result.data.bedArr.map(BedN => (BedN.bed_name))
            this.hospitalBedData.bedNames = bedNameArrData
            const bedNameBnArrData = result.data.bedArr.map(BedNbn => (BedNbn.bed_name_bn))
            this.hospitalBedData.bedNameBns = bedNameBnArrData
            this.unitLoad = false
        } else {
            this.hospitalBedData = {}
            this.unitLoad = false
        }
    },
    async createData () {
        this.$store.dispatch('mutateCommonProperties', { loading: true })
        let result = null
        const loadinState = { loading: false, listReload: true }
        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }

        if (this.$route.query.ward_id) {
            result = await RestApi.putData(hospitalServiceBaseUrl, `${hospitalBedUpdateApi}/${this.$route.query.ward_id}`, this.hospitalBedData, config)
        } else {
            result = await RestApi.postData(hospitalServiceBaseUrl, hospitalBedStoreApi, this.hospitalBedData, config)
        }

        this.$store.dispatch('mutateCommonProperties', loadinState)

        if (result.success) {
            this.$store.dispatch('mutateCommonProperties', { hasDropdownLoaded: false })
            this.$toast.success({
            title: this.$t('globalTrans.success'),
            message: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save_msg'),
            color: '#D6E09B'
            })

            this.$bvModal.hide('modal-4')
            this.$router.push('/hospital-disability-service/configuration/hospital-bed')
        } else {
            this.$refs.form.setErrors(result.errors)
        }
    }
  }
}
</script>
